import { createClient } from '@supabase/supabase-js'

import { entorno } from '@/lib/entorno'

import type { Database } from './tipos-bd'

/**
 * Cliente único de Supabase para toda la aplicación.
 *
 * Se crea una sola vez a propósito: cada instancia abre su propia conexión de
 * tiempo real y su propio temporizador de refresco de sesión. Dos instancias
 * se pelean por renovar el mismo token y terminan sacando al usuario.
 *
 * La llave que viaja aquí es la pública. Toda la seguridad real vive en las
 * políticas RLS (supabase/migrations/0008_politicas_rls.sql).
 */
export const supabase = createClient<Database>(entorno.supabaseUrl, entorno.supabaseAnonKey, {
  auth: {
    persistSession: true,
    autoRefreshToken: true,
    detectSessionInUrl: true,
    storageKey: 'mega-ordenes-sesion',
  },
  db: {
    schema: 'public',
  },
  global: {
    headers: {
      'x-cliente': 'mega-ordenes-web',
    },
  },
})
